export const CRM_MEETING_PREP_MVP_FLAG_KEY = 'crm_meetingprep_mvp'
export const CRM_ORG_SETTINGS_FLAG_KEY = 'crm_org_settings'
export const CRM_UNIFIED_MEETING_BRIEFS_FLAG_KEY = 'crm_unified_meeting_briefs'
